import React, { Component } from 'react'
import Firebase from "firebase/app"
import 'firebase/database'

import {
    CustomEventPicker,
    CustomTimePicker,
    CustomProductPicker,
    WheelChairPicker,
    GuestsInputForm,
    MailInfoPicker
} from './CustomPickers'

import {ReservationResult, EventDetailsDisplay} from './CustomDisplay'

import {
    validateField,
    parseEvents,
    getAvailableSpace,
    getCurrentOccupation,
    reservationGuestsCount,
    sendReservationEmail,
    sendProductsEmail,
    filterParkings,
    sumReservedAndCurrentParkings
} from '../utils'

import {
    FAILED_STATE,
    COMPLETED_STATE,
    PENDING_STATE,
    NOT_CHOOSEN_STATE,
    NAME_FIELD,
    NUMBER_FIELD,
    MAIL_FIELD,
    PLATE_FIELD
} from "../constants"

import {
    NO_ROOM_ERROR,
    INVALID_NAME_ERROR,
    INVALID_PHONE_ERROR,
    INVALID_MAIL_ERROR,
    INVALID_PLATE_ERROR,
    RESERVATION_BUTTON,
    CHOOSE_AN_OPTION_TEXT,
    SANITARY_MEASURES_TEXT
} from '../strings'


class RegisterForm extends Component {

    constructor(props) {
        super(props)

        this.state = {
            events: {},
            parkings: {},
            reservedParkings: {},
            selectedEventId: null,
            reservation: {
                personalData: {name: "", phone: "", mail: "", plate: ""},
                guests: [{name: ""}, {name: ""}],
                wheelChair: false,
                mailInfo: true,
                checkIn: false,
                products: [],
                selectedTime: 0
            },
            reservationId: Math.random().toString(36).substr(2, 9),
            reservationState: NOT_CHOOSEN_STATE,
            errorMessages: {
                personalDataName: false,
                personalDataPhone: false,
                personalDataMail: false,
                personalDataPlate: false,
                guests: [false, false],
                notAvailableSpace: false
            },
            parkingReservationState: ""
        }

        this.parkingsRef = Firebase.database().ref(`/parkings`)
        this.reservedParkingsRef = Firebase.database().ref(`/reservedParkings`)

        this.createReservation = this.createReservation.bind(this)
        this.handleInputChange = this.handleInputChange.bind(this)
        this.handleEventChange = this.handleEventChange.bind(this)
        this.handlePersonalDataChange = this.handlePersonalDataChange.bind(this)
        this.handleTimeChange = this.handleTimeChange.bind(this)
        this.handleWheelChairChange = this.handleWheelChairChange.bind(this)
        this.handleMailInfoChange = this.handleMailInfoChange.bind(this)
        this.handleProductSelected = this.handleProductSelected.bind(this)
        this.getReservationErrors = this.getReservationErrors.bind(this)
        this.reserveParking = this.reserveParking.bind(this)
        this.checkForParkingSpace = this.checkForParkingSpace.bind(this)
    }

    getReservationErrors(){
        const {errorMessages, reservation} = this.state
        if (errorMessages.notAvailableSpace){
            return NO_ROOM_ERROR
        }
        if (errorMessages.personalDataName || !reservation.personalData.name){
            return INVALID_NAME_ERROR
        }
        if (errorMessages.personalDataPhone || !reservation.personalData.phone){
            return INVALID_PHONE_ERROR
        }
        if (errorMessages.personalDataMail || !reservation.personalData.mail){
            return INVALID_MAIL_ERROR
        }
        if (errorMessages.personalDataPlate){
            return INVALID_PLATE_ERROR
        }
        const guestsValues = Object.values(errorMessages.guests)
        const guestError = guestsValues.indexOf(true)
        if (guestError !== -1){
            return `El nombre del invitado ${guestError + 1} no es válido`
        }
        return false
    }

    createReservation(){
        const {
            reservationId, events, selectedEventId, reservation, errorMessages
        } = this.state
        const {getReservationErrors, reserveParking} = this

        const reservationErrors = getReservationErrors()
        if (reservationErrors){
            this.setState({
                reservationState: FAILED_STATE
            })
            return
        }

        // Check available space
        const availableSpace = getAvailableSpace(
            events[selectedEventId], reservation.selectedTime
        )
        const totalGuestsReservation = reservationGuestsCount(reservation)
        if (totalGuestsReservation > availableSpace){
            errorMessages.notAvailableSpace = true
            this.setState({
                errorMessages: errorMessages
            })
            return
        }

        // Register occupation
        const ocupationDocumentUrl = (
            `/events/${selectedEventId}/availableHours/` +
            `${reservation.selectedTime}`
        )
        const currentOccupation = getCurrentOccupation(
            events[selectedEventId], reservation.selectedTime
        )
        Firebase.database().ref(ocupationDocumentUrl).set(
            currentOccupation + totalGuestsReservation
        )

        // Register parking if any
        const requiresParking = reservation.personalData.plate.length > 0
        if (requiresParking){
            const startTime = reservation.selectedTime
            const endTime = startTime + 60*60*1000
            const plate = reservation.personalData.plate
            reserveParking(plate, startTime, endTime, reservationId)
        }

        // Register guests
        const dbUrl = `/guests/${selectedEventId}/${reservationId}`
        Firebase.database().ref(dbUrl).set(reservation)
            .then(() => {
                // Send email
                if (!requiresParking){
                    sendReservationEmail(
                        reservationId,
                        reservation,
                        events[selectedEventId].name,
                        'No'
                    )
                }
                if (reservation.products.length > 0){
                    sendProductsEmail(
                        reservationId,
                        reservation,
                        events[selectedEventId].name
                    )
                }
                this.setState({
                    reservationState: COMPLETED_STATE
                })
            })
            .catch((error) => {
                this.setState({
                    reservationState: FAILED_STATE
                })
            })
    }

    handleInputChange(index, value){
        const {reservation, errorMessages} = this.state
        errorMessages.guests[index] = value ? !validateField(NAME_FIELD, value) : false
        reservation.guests[index].name = value
        errorMessages.notAvailableSpace = false
        this.setState({
            reservation: reservation,
            errorMessages: errorMessages
        })
    }

    handleEventChange(event){
        const {events} = this.state
        const eventId = event.target.value
        if (eventId === CHOOSE_AN_OPTION_TEXT){
            this.setState({
                selectedEventId: null,
                reservation: {
                    personalData: {name: "", phone: "", mail: "", plate: ""},
                    guests: [{name: ""}, {name: ""}],
                    wheelChair: false,
                    mailInfo: true,
                    checkIn: false,
                    products: [],
                    selectedTime: 0
                },
                errorMessages: {
                    personalDataName: false,
                    personalDataPhone: false,
                    personalDataMail: false,
                    personalDataPlate: false,
                    guests: [false, false],
                    notAvailableSpace: false
                },
                reservationState: NOT_CHOOSEN_STATE,
                parkingReservationState: ""
            })
            return
        }

        this.setState({
            selectedEventId: eventId,
            reservationState: PENDING_STATE,
            reservation: {
                personalData: {name: "", phone: "", mail: "", plate: ""},
                guests: [{name: ""}, {name: ""}],
                wheelChair: false,
                mailInfo: true,
                checkIn: false,
                products: [],
                selectedTime: events[eventId].availableHours[0].time
            },
            reservationId: Math.random().toString(36).substr(2, 9),
            errorMessages: {
                personalDataName: false,
                personalDataPhone: false,
                personalDataMail: false,
                personalDataPlate: false,
                guests: [false, false],
                notAvailableSpace: false
            },
            parkingReservationState: ""
        })
    }

    handleTimeChange(event){
        const {reservation, errorMessages} = this.state
        const timeSelected = event.target.value
        reservation.selectedTime = Number(timeSelected)
        errorMessages.notAvailableSpace = false
        this.setState({
            errorMessages: errorMessages,
            reservation: reservation
        })
    }

    handleProductSelected(productName, productValue){
        const {reservation} = this.state
        const productIsSelected = reservation.products.map(
            el => {return el.name}
        ).includes(productName)
        if (productIsSelected){
            // Remove product
            for (var index in reservation.products){
                if (reservation.products[index].name === productName){
                    break
                }
            }
            reservation.products.splice(index, 1)
        } else{
            reservation.products.push({name: productName, value: productValue})
        }
        this.setState({
            reservation: reservation
        })
    }

    handlePersonalDataChange(nameValue, phoneValue, mailValue, plateValue){
        const{reservation, errorMessages} = this.state
        const formattedPhone = phoneValue.replace("-", "").replace(" ", "")
        // Check for plate
        var formattedPlate = plateValue.replace(" ", "")
        const regexAlphaNum = /^[a-zA-Z]{3}$/
        if (regexAlphaNum.test(formattedPlate)){
            // This is an alpha num plate, add - automatically
            formattedPlate += "-"
        }

        errorMessages.personalDataName = nameValue ? !validateField(NAME_FIELD, nameValue) : false
        errorMessages.personalDataPhone = formattedPhone ? !validateField(NUMBER_FIELD, formattedPhone) : false
        errorMessages.personalDataMail = mailValue ? !validateField(MAIL_FIELD, mailValue) : false
        errorMessages.personalDataPlate = plateValue ? !validateField(PLATE_FIELD, formattedPlate) : false

        reservation.personalData = {
            name: nameValue, phone: formattedPhone, mail: mailValue, plate: formattedPlate
        }
        this.setState({
            errorMessages: errorMessages,
            reservation: reservation
        })
    }

    handleWheelChairChange(event){
        const {reservation} = this.state
        reservation.wheelChair = !reservation.wheelChair
        this.setState({
            reservation: reservation
        })
    }

    handleMailInfoChange(event){
        const {reservation} = this.state
        reservation.mailInfo = !reservation.mailInfo
        this.setState({
            reservation: reservation
        })
    }

    reserveParking(plate, startTime, endTime, resId){
        const {parkings} = this.state
        const {checkForParkingSpace} = this
        const parkingPriorities = Object.keys(parkings).map(parkingId => {
            return parkings[parkingId].priority
        })
        parkingPriorities.sort()
        const orderedParkingsIds = []
        for (var i in parkingPriorities){
            for (var parkingId in parkings){
                if (parkings[parkingId].priority === parkingPriorities[i]){
                    orderedParkingsIds.push(parkingId)
                }
            }
        }
        // Now iterate over ordered parkings by priority and try to find space
        checkForParkingSpace(orderedParkingsIds, 0, plate, startTime, endTime, resId)
    }

    checkForParkingSpace(orderedParkingsIds, index, plate, startTime, endTime, resId){
        const {parkings, selectedEventId, reservationId, reservation, events} = this.state
        const {reservedParkingsRef, checkForParkingSpace} = this
        if (index >= orderedParkingsIds.length){
            sendReservationEmail(
                reservationId,
                reservation,
                events[selectedEventId].name,
                'Si, pero no se encontró espacio en parqueos'
            )

            if (reservation.products.length > 0){
                sendProductsEmail(
                    reservationId,
                    reservation,
                    events[selectedEventId].name
                )
            }
            this.setState({
                parkingReservationState: `**No fue posible reservar espacio para el vehículo`
            })
            return
        }
        const parkingId = orderedParkingsIds[index]
        reservedParkingsRef.child(parkingId).orderByKey().startAt(
            startTime.toString()).once('value', snapshot => {
                var reservedParkings = snapshot.val()
                if (reservedParkings == null){
                    reservedParkings = {}
                }
                var currentParkingId = snapshot.ref.key;
                const currentOccupation = parkings[currentParkingId].currentOccupation
                const filteredParkings = filterParkings(reservedParkings, startTime, endTime)
                sumReservedAndCurrentParkings(filteredParkings, currentOccupation, endTime)
                const parkingCapacity = parkings[currentParkingId].capacity
                if (filteredParkings.length < parkingCapacity){
                    // We have space in here
                    reservedParkingsRef.child(
                        `${currentParkingId}/${endTime}/${selectedEventId}/${resId}`
                    ).set({
                        'plate': plate,
                        'start': startTime
                    })
                    const parkingName = parkings[currentParkingId].name
                    sendReservationEmail(
                        reservationId,
                        reservation,
                        events[selectedEventId].name,
                        `Si, se reservo espacio para la placa ${plate} en ${parkingName}`
                    )
                    if (reservation.products.length > 0){
                        sendProductsEmail(
                            reservationId,
                            reservation,
                            events[selectedEventId].name
                        )
                    }
                    this.setState({
                        parkingReservationState: `Se reservó un espacio para el vehículo en ${parkingName}`
                    })
                    return
                }
                return checkForParkingSpace(orderedParkingsIds, index + 1, plate, startTime, endTime, resId)
            })
    }

    componentDidMount(){
        // Get all events that has end timestamp now or in the future
        const {parkingsRef} = this
        const ref = Firebase.database().ref('/events')

        ref.orderByChild('end').startAt(new Date().getTime()).on('value', snapshot => {
            var eventsRaw = snapshot.val();
            if (eventsRaw === null){
                eventsRaw = {}
            }
            const availableEvents = parseEvents(eventsRaw, false)
            this.setState({
                events: availableEvents
            })
        })

        parkingsRef.on('value', snapshot => {
            var parkingsRaw = snapshot.val()
            if (parkingsRaw == null){
                parkingsRaw = {}
            }
            this.setState({
                parkings: parkingsRaw
            })
        })
    }

    render() {
        const {
            selectedEventId,
            reservationState,
            errorMessages,
            reservationId,
            events,
            reservation,
            parkingReservationState
        } = this.state
        const {
            createReservation,
            handleInputChange,
            handleEventChange,
            handlePersonalDataChange,
            handleTimeChange,
            handleProductSelected,
            getReservationErrors,
            handleWheelChairChange,
            handleMailInfoChange
        } = this
        const availableSpace = selectedEventId ? getAvailableSpace(
            events[selectedEventId], reservation.selectedTime
        ) : 0
        return (
            <div className="registerForm">
                <div className="register-form-header-container">
                    <CustomEventPicker
                        events={events}
                        selectedEventId={selectedEventId}
                        onEventSelected={handleEventChange}
                        disabled={reservationState === COMPLETED_STATE}
                    />
                    {
                        selectedEventId ?
                        <div>
                            <EventDetailsDisplay
                                events={events}
                                selectedEventId={selectedEventId}
                            />
                        </div> : <div></div>
                    }
                </div>
                <div className="shadow-box"></div>
                {
                    reservationState === NOT_CHOOSEN_STATE ?
                    <div className="empty-div-fixed-height"></div> :
                    <div className="div-align-block">
                        <div className="container-event-details">
                            <div className="time-selection-block inline-element">
                                <CustomTimePicker
                                    availableHours={events[selectedEventId].availableHours}
                                    selectedTime={reservation.selectedTime}
                                    availableSpace={availableSpace}
                                    onTimeSelected={handleTimeChange}
                                    showWarning={true}
                                    disabled={reservationState === COMPLETED_STATE}
                                />
                            </div>
                            <div className="product-selection-block inline-element">
                                <CustomProductPicker
                                    productsSelected={reservation.products}
                                    onProductSelected={handleProductSelected}
                                />
                            </div>
                        </div>
                        <div className="div-align-block">
                            <GuestsInputForm
                                personalData={reservation.personalData}
                                guests={reservation.guests}
                                errorMessages={errorMessages}
                                disabled={
                                    reservationState === COMPLETED_STATE ||
                                    availableSpace <= 0
                                }
                                handlePersonalDataChange={handlePersonalDataChange}
                                handleGuestInputChange={handleInputChange}
                            />
                        </div>
                        <div>
                            <WheelChairPicker
                                wheelChairRequired={reservation.wheelChair}
                                onChange={handleWheelChairChange}
                                disabled={reservationState === COMPLETED_STATE}
                            />
                        </div>
                        <div>
                            <MailInfoPicker
                                mailInfoData={reservation.mailInfo}
                                onChange={handleMailInfoChange}
                                disabled={reservationState === COMPLETED_STATE}
                            />
                        </div>
                        <div>
                            <input
                                type="button"
                                className="button-add-reserve"
                                value={RESERVATION_BUTTON}
                                disabled={
                                    reservationState === COMPLETED_STATE ||
                                    availableSpace <= 0
                                }
                                onClick={createReservation}></input>
                        </div>
                        <div>
                            <ReservationResult
                                reservationState={reservationState}
                                reservationId={reservationId}
                                reservationProducts={reservation.products}
                                parkingReservationState={parkingReservationState}
                                errorMessages={getReservationErrors()}
                            />
                        </div>
                        <div className="sanitary-measures-reminder-text">
                            <div className="sanitary-measures-title">Por la salud de todos</div>
                            <div>{SANITARY_MEASURES_TEXT}</div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

export default RegisterForm
